import './ReportOnOff.css'

import React, { useEffect, useState } from 'react';

import utils from "../Services/dateTimeUtils";

export default function ReportOnOff({ list }) {


    useEffect(() => {

    }, [])

   


    return (
        <>
            {
                <div className="row " id= "reportOnOff">
                    <div className="col">
                        <div className="table-responsiv table-fixed">
                            <table className="table  table-striped table-hover ">
                                <thead>
                                    <tr>
                                        <th scope="col">ردیف</th>
                                        <th scope="col">از تاریخ </th>
                                        <th scope="col">از ساعت</th>
                                        <th scope="col">تا تاریخ </th>
                                        <th scope="col">تا ساعت </th>
                                        <th scope="col">وضعیت</th>
                                        <th scope="col">به مدت </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((item, index) => (
                                        <tr key={"ff"+index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{item.dtFromFa}</td>
                                            <td>{item.timeFrom}</td>
                                            <td>{item.dtToFa}</td>
                                            <td>{item.timeTo}</td>
                                            <td>{item.switch==0?'خاموش':'روشن'}</td>
                                            <td>{utils.toHHMM(item.len)}</td>
                                        </tr>)
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}